<script>
    import { onMount } from 'svelte';
    import { fetchUserByResetHash } from '../services/users/users';
    import ResetPassword from '/public/components/users/ResetPassword.svelte';

    let loading = true;

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;

    let user = null;

    onMount(() => {
        fetchUserByResetHash(hash).then(res => {
            if (res.success) {
                user = res.data.user;
                loading = false;
            }
        });
    });


</script>

<div class="row justify-content-center mt-3 mb-3">
    <div class="col-sm-10 col-md-6 col-lg-4">
        {#if loading === true}
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden"></span>
            </div>
            Searching for your account...
        {:else}
            <ResetPassword user={user} hash={hash}/>
        {/if}
    </div>
</div>
